<template>
  <aw-dropdown
    v-if="enable"
    placement="bottom-end"
    :offset="[0, 2]"
    class="relative z-20"
  >
    <template v-slot:btn="{ open }">
      <button 
        class="pill__Button"
        @click="open"
      >
        <aw-icon icon="search"/>
      </button>
    </template>
    <template v-slot:dropdown="{ opened, dropdown }">
      <div
        class="Dropdown FiltersDropdown--Wrapper absolute flex flex-col items-end gap-y-2 rounded-lg shadow-md bg-white w-auto text-sm z-10 p-2"
        v-show="opened"
        :ref="dropdown"
      >
        <slot/>
      </div>
    </template>
  </aw-dropdown>
  <slot v-else/>
</template>

<script>
export default {
  props: {
    enable: {
      type: Boolean,
      default: false
    },
  },
}
</script>

<style lang="scss">
.FiltersDropdown--Wrapper {
  border-radius: 24px;
  @apply w-52;

  >form{
    @apply flex flex-col max-w-xs w-full space-y-2;

    >* {
      width: 100%;
    }
  }

  .pill__SearchInput {
    @apply w-full;
  }
}
</style>
